import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { createCardExport } from '@shared/api/mutations/cards';

import { API } from '@shared/types/api';
interface CardExportResponse {
  isLoading: boolean;
  error?: string;
  url?: string;
}

interface CardExport {
  createCardExport(cardId: string): void;
  response: CardExportResponse;
}

export function useCardExport(): CardExport {
  const [create, { loading, data, error }] = useMutation<
    API.CreateCardExportMutation,
    API.CreateCardExportMutationVariables
  >(createCardExport);

  const createExport = useCallback(
    async (cardId: string) => {
      await create({
        variables: {
          input: {
            id: cardId,
            format: 'PDF',
          },
        },
      });
    },
    [create],
  );

  return {
    createCardExport: createExport,
    response: {
      isLoading: loading,
      error: error?.message,
      url: data?.createCardExport?.url ?? undefined,
    },
  };
}
